export const EVIDENCE_ROUTE_PATHS = {
  dashboard: '/new-evidence/dashboard',
  myDashboard: '/new-evidence/my-dashboard',
  records: '/new-evidence/records',
  disposal: '/new-evidence/disposal',
  audit: '/new-evidence/audit',
  analytics: '/new-evidence/analytics',
  portal: '/portal',
  portalLogin: '/portal/login',
};
